// extracted by mini-css-extract-plugin
module.exports = {"modalBackButton":"ConfirmModal_modalBackButton__pL1dn","modalSubmitButton":"ConfirmModal_modalSubmitButton__L_uI0"};